// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"bd3bc026","594":"46c81abd","837":"3b913f89"}[chunkId] + ".chunk.css";
};